
    import {Inject, Options, Prop, Ref, Vue} from 'vue-property-decorator';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {FreelancerTagsService, TagSuggestion} from '@/profile-creation-wizard/components/for-creation/FreelancerTagsService';
    import {HttpServiceResponse} from 'vue3-starter/src/typescript/http/http';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import Autocomplete from '@malt/joy-entrypoint/src/vue/Autocomplete.vue';

    class Searcher {
        private freelancerTagsService: FreelancerTagsService;

        constructor(service: FreelancerTagsService) {
            this.freelancerTagsService = service;
        }

        async search(query: string): Promise<HttpServiceResponse<any>> {
            const [data, error] = await this.freelancerTagsService.autocomplete(query);
            if (error) {
                return [[query], null];
            }

            if (data && !error) {
                const tags = data?.map((tag: TagSuggestion) => tag.label);
                const isMatching = !!tags.find((tag: string) => {
                    return tag.trim().toLowerCase() === query?.trim().toLowerCase();
                });
                if (!isMatching) {
                    tags.push(query);
                }
                return [tags, error];
            }

            return [null, error];
        }
    }

    @Options({
        components: {
            Autocomplete,
        },
    })
    export default class InputSelectTags extends Vue {
        @Inject({from: DI.freelancerTagsService})
        freelancerTagsService!: FreelancerTagsService;
        @Prop({type: Boolean, default: false})
        disabled!: false;
        @Prop({type: String, default: 'profile.creation.completion.wizard.v2.details.skills.placeholder'})
        placeholder!: '';
        @Ref('autocomplete')
        autocomplete!: HTMLElement;

        private query = '';
        private options: string[] = [];
        private selected = '';

        private searcher!: Searcher;

        created(): void {
            this.$requireMsg('profile.creation.completion.wizard.v2.details.skills.placeholder');
            this.searcher = new Searcher(this.freelancerTagsService);
        }

        get excludes() {
            return this.$store.state.form.tags.map((item) => item.name);
        }

        get isEmpty(): boolean {
            return this.options.length === 0;
        }

        get selectPlaceholder(): string {
            return this.$msg(this.placeholder);
        }

        onSelect(input: any): void {
            this.selected = input;
            this.$emit('update:tag', new Tag(this.selected));
            this.selected = '';
            this.query = '';
            this.options = [];
        }

        emitFocus(): void {
            eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.tags);
        }
    }
